import { Organisation } from '@/payload-types'
import React, { ReactElement } from 'react'
import { isMedia } from '@/lib/utils'
import Link from 'next/link'
import Image from 'next/image'
import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent } from '@/components'

interface GlobalFooterOrganisationProps {
  organisation: Organisation
}

function GlobalFooterOrganisation({
  organisation,
}: Readonly<GlobalFooterOrganisationProps>): ReactElement | null {
  const name = organisation.name
  const website = organisation.website
  const logo = organisation.logo

  if (website && logo && isMedia(logo)) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Link href={website} target="_blank" rel="nofollow">
              <Image
                className="w-auto max-h-16"
                src={String(logo.url)}
                alt={name}
                width={Number(logo.width)}
                height={Number(logo.height)}
                sizes="96px"
                priority
              />
            </Link>
          </TooltipTrigger>
          <TooltipContent>
            <p className="p-0 m-0 text-center">{name}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    )
  } else if (logo && isMedia(logo)) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Image
              className="w-auto max-h-16"
              src={String(logo.url)}
              alt={name}
              width={Number(logo.width)}
              height={Number(logo.height)}
              sizes="96px"
              priority
            />
          </TooltipTrigger>
          <TooltipContent>
            <p className="p-0 m-0 text-center">{name}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    )
  } else {
    return null
  }
}

export { GlobalFooterOrganisation }
